import axios from 'axios';

export type PermissionsTypeV2 = {
  subjectId: string;
  branchIndex: string | null;
  lockboxId: string;
  permissionType: 'owner' | 'assignee';
  ownerOrAssigneeType: 'org' | 'branch' | 'user' | 'office';
};

const assignSupraLockboxV2 = async ({
  permissions,
  granteeUserIds,
  officePermissionsGenerated,
}: {
  permissions: PermissionsTypeV2[];
  granteeUserIds: string[];
  officePermissionsGenerated?: boolean;
}) => {
  await axios.post('/supra/lockbox/assign_user_v2', {
    permissions,
    granteeUserIds,
    officePermissionsGenerated,
  });
};

export default assignSupraLockboxV2;
